import React, { useState } from "react";
import { Grid2 } from "@mui/material";
import styles from "./ExpandableRow.module.scss";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import CustomButton from "../CustomButton/CustomButton";

const ExpandableRow = (props) => {
  const {
    sno,
    header,
    subHeader,
    steps = [],
    button,
    buttonTitle,
    success,
    successTitle,
    onClick,
    subHeaderClick,
    link,
    text,
    textClick,
    expandedRow,
    setExpandedRow,
  } = props;

  //const [isExpanded, setIsExpanded] = useState(false);
  const [copied, setCopied] = useState(false);

  // const toggleExpand = () => {
  //   setIsExpanded(!isExpanded);
  // };

  const isExpanded = expandedRow === sno;

  const toggleExpand = () => {
    setExpandedRow(isExpanded ? null : sno);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);

    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <Grid2 className={styles.MigrationTableContainer} onClick={toggleExpand}>
        <Grid2 className={styles.sno}>{sno}</Grid2>
        <Grid2 className={styles.FlexHeader}>
          <Grid2>
            <Grid2 className={styles.header}>{header}</Grid2>
          </Grid2>
          <Grid2 className={styles.isExpanded}>
            {isExpanded ? (
              <UnfoldLessIcon className={styles.icon} />
            ) : (
              <UnfoldMoreIcon className={styles.icon} />
            )}
          </Grid2>
        </Grid2>

        {isExpanded && (
          <Grid2 className={styles.expandedContent}>
            {button && !success ? (
              <Grid2 className={styles.button}>
                <CustomButton onClick={onClick}>{buttonTitle}</CustomButton>
              </Grid2>
            ) : (
              <Grid2 className={styles.successTitle}>{successTitle}</Grid2>
            )}

            {isExpanded && (
              <>
                <span onClick={textClick} className={styles.textColor}>
                  {text}
                </span>
                <Grid2 className={styles.subHeader} onClick={subHeaderClick}>
                  {subHeader}
                </Grid2>
                {link && (
                  <>
                    <Grid2 className={styles.linkContainer}>
                      <span className={styles.linkText}>{link}</span>
                      <ContentCopyIcon
                        className={styles.copyIcon}
                        onClick={handleCopy}
                      />
                    </Grid2>
                    {copied && (
                      <span className={styles.linkCopyText}>Link Copied!</span>
                    )}
                  </>
                )}
              </>
            )}

            {steps.map((step, index) => (
              <ol key={index}>
                {step.title && (
                  <span className={styles.stepText}>{`${index + 1}. ${
                    step.title
                  }`}</span>
                )}

                {typeof step.subTitle === "string" ? (
                  step.subTitle
                ) : (
                  <>{step.subTitle}</>
                )}
                {step.subSteps && (
                  <ol style={{ listStyleType: "lower-alpha" }}>
                    {step.subSteps.map((subStep, subIndex) => (
                      <li key={subIndex}>
                        <span className={styles.stepText}>{subStep.text}</span>
                        {subStep.image && (
                          <div className={styles.stepImage}>
                            {subStep.image}
                          </div>
                        )}
                      </li>
                    ))}
                  </ol>
                )}
                <div className={styles.stepImage}>{step.image}</div>
              </ol>
            ))}
          </Grid2>
        )}
      </Grid2>
    </>
  );
};

export default ExpandableRow;
